<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div class="trip-plan-wrapper" *ngIf="!tripPlan?.isNextSame">
	<div class="plan-created row">
		<span>{{locoLabel?.planCreated}}:</span>
		<span>{{tripPlan?.tripCreateTS|locoBlankString}}</span>
	</div>
	<div class="train-num row">
		<span class="train-id">{{tripPlan?.tripTrain|locoBlankString}}</span>
		<span><strong>{{leftPad(tripPlan?.tripTrainRouteSeq,'0',3)}}</strong></span>
	</div>
	<div class="row origin-destination">
		<div class="icons">
			<span class="icon-origin"></span>
			<span class="icon-destination"></span>
		</div>
		<div class="origin">
			<span class="terminal">{{appUtilityService.isValidTerminalId(tripPlan?.tripTrainArrStation)?tripPlan?.tripTerminal:'-'}}</span>
			<span *ngIf="tripPlan?.tripTrainArrDate">{{locoLabel?.planDep}}{{tripPlan?.tripDate}}</span>
		</div>
		<div class="destination">
			<span class="terminal">{{appUtilityService.isValidTerminalId(tripPlan?.tripTrainArrStation)?tripPlan?.tripTrainArrStation:tripPlan?.tripTerminal}}</span>
			<span>{{locoLabel?.planEta}}{{tripPlan?.tripTrainArrDate?tripPlan?.tripTrainArrDate:tripPlan?.tripDate}}</span>
		</div>
	</div>
</div>